import { useState, useEffect } from 'react';
import { isBrowser } from 'ws-scripts/modules/environment';

export const useScrollEffect = ({
	ref,
	navbarHeight,
	stuckSelector,
	stuckEnabled = true
}) => {
	const [isScrolled, setScroll] = useState(false);
	const [isFilterBarStuck, setIsFilterBarStuck] = useState(false);
	const filterPosition = ref.current ? ref.current.offsetTop : 0;
	const filterPositionCalc = filterPosition - navbarHeight;

	useEffect(() => {
		if (!isBrowser) return undefined;

		const handleScroll = ref && ref.current
			? window._.debounce(() => {
					setScroll(window.scrollY >= filterPositionCalc);
			  }, 0)
			: null;

		const target =
			stuckEnabled && stuckSelector
				? document.querySelector(stuckSelector)
				: null;
		const checkStuck = target
			? () => {
					setIsFilterBarStuck(
						target.getBoundingClientRect().top <= navbarHeight
					);
			  }
			: null;

		const onScroll = () => {
			if (handleScroll) handleScroll();
			if (checkStuck) checkStuck();
		};

		if (checkStuck) checkStuck();
		document.addEventListener('scroll', onScroll);
		return () => document.removeEventListener('scroll', onScroll);
	}, [
		ref,
		filterPosition,
		filterPositionCalc,
		stuckSelector,
		navbarHeight,
		stuckEnabled
	]); // eslint-disable-line react-hooks/exhaustive-deps

	return { isScrolled, isFilterBarStuck };
};
